// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_g8-0";
export var fileCarousel = "_g8-2";
export var removeFileButton = "_g8-1";